import { configureStore } from "@reduxjs/toolkit";
import locationsReducer from "./locations/locationSlice";
import usersReducer from "./users/userSlice";
import rostersReducer from "./rosters/rosterSlice";
import profileReducer from "./profile/profileSlice";
import tenantReducer from "./roles/rolesSlice";
import wardReducer from "./ward/wardSlice";
import statusFailReducer from "./statusFail/statusFailSlice";
import billingReducer from "./billing/billingSlice";
import serviceReducer from "./service/serviceSlice";
import packageReducer from "./package/packageSlice";
import diagnosticReducer from "./diagnostic/diagnosticSlice";
import pharmacyReducer from "./pharmacy/pharmacySlice";
const store = configureStore({
  reducer: {
    locations: locationsReducer,
    billing: billingReducer,
    users: usersReducer,
    rosters: rostersReducer,
    profile: profileReducer,
    tenant: tenantReducer,
    ward: wardReducer,
    statusFail: statusFailReducer,
    service: serviceReducer,
    package:packageReducer,
    diagnostic: diagnosticReducer,
    pharmacy:pharmacyReducer
  },
});

export default store;
